/** @format */

export default {
	SET_CURRENCIES: 'SET_CURRENCIES',
	SET_AVAILABLE_CURRENCIES: 'SET_AVAILABLE_CURRENCIES',
	SET_ENABLED_CURRENCIES: 'SET_ENABLED_CURRENCIES',
	SET_DEFAULT_CURRENCY: 'SET_DEFAULT_CURRENCY',
	SET_CURRENCY_SETTINGS: 'SET_CURRENCY_SETTINGS',
	SET_STORE_SETTINGS: 'SET_STORE_SETTINGS',
	SET_STORE_SETTINGS_VALUES: 'SET_STORE_SETTINGS_VALUES',
	SET_IS_SAVING_STORE_SETTINGS: 'SET_IS_SAVING_STORE_SETTINGS',
};
